<template>
    <TermsCheck
        :is-loading="isLoading"
        :content="listText"
        @goNext="goNext"
    />
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { getAgreeTermsA7, postAgreeA7 } from '@/apis/A7';
import routeName from '@/router/constant.js';
import TermsCheck from '@/components/template/TermsCheck.vue';

export default {
    components: {
        TermsCheck
    },
    setup() {
        const router = useRouter();
        const listText = ref('');
        const isLoading = ref(false);
        getAgreeTermsA7().then((res) => {
            listText.value = res.data.agreeTerms.content;
        });

        const goNext = () => {
            isLoading.value = true;
            postAgreeA7().then(() => {
                router.push({
                    name: routeName.TERMINATE
                });
            }).finally(() => {
                isLoading.value = false;
            });
        };
        return {
            listText,
            isLoading,
            goNext
        };
    },
};
</script>
